import { StrictMode } from 'react';
import { Boundary } from './components/Boundary';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

/* One webfont, not three.
   Body and data use the system stacks (SF on iOS) — nothing to download,
   nothing to precache, and instantly available on a phone with no signal.
   The only face we ship is the serif that carries the headings. */
import '@fontsource-variable/newsreader';

import { claimRoomToken } from '@kilroy/shared';
import '@kilroy/shared/tokens.css';
import './design/base.css';
import './app/shell.css';

import { App } from './app/App';

/* A room token arriving on the URL, claimed BEFORE React mounts.
 *
 * It has to be before: the router — and on the phone a sign-in wall in front of
 * it — would meet `/enter/<token>` as an unknown route and discard it. This
 * sets the cookie and rewrites the address bar, so the app boots normally and
 * the dock finds the token already waiting for it. */
claimRoomToken();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Boundary>
        <App />
      </Boundary>
    </BrowserRouter>
  </StrictMode>,
);
